import add from "./addUserRole";
import edit from "./editUserRole";

export default {
  add,
  edit,
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/ssoUserRole/index.js